module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-bounce-in-down/wow-bounce-in-down.component.scss
// module id = ./src/app/features/wow-slider/wow-bounce-in-down/wow-bounce-in-down.component.scss
// module chunks = main